import { render, staticRenderFns } from "./Profiling.vue?vue&type=template&id=2af71026"
import script from "./Profiling.vue?vue&type=script&lang=js"
export * from "./Profiling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports